import { getApps, initializeApp } from "firebase/app"
import { getMessaging, isSupported } from "firebase/messaging"

const firebaseConfig = {
  apiKey: "AIzaSyAnCSOpgNpVDuHorUWKWbaBlzjQuaCKkV4",
  projectId: "baanruejai-1749",
  messagingSenderId: "968668258607",
  appId: "1:968668258607:web:a2556aa321b43ba91e01da",
}

let messagingPromise = null

// Resolves to the shared Messaging instance, or null when the browser does
// not support Firebase Messaging (no service worker / Push API support).
export function getMessagingIfSupported() {
  if (!messagingPromise) {
    messagingPromise = isSupported()
      .then((supported) => {
        if (!supported) return null

        const app = getApps().length
          ? getApps()[0]
          : initializeApp(firebaseConfig)

        return getMessaging(app)
      })
      .catch(() => null)
  }

  return messagingPromise
}
